<template>
  <!-- eslint-disable-next-line vue/no-unused-refs -->
  <base-list-management ref="baseListManagement" :configData.sync="configData"/>
</template>
<script>
import diffConfigFn from './config'
import { CUSTOMER_TYPE } from '../../config'
import { getAccidentList } from '@/api/domain/carsService'
import { accidentList } from '@/api/serviceAPi'

const API_CONF = {
  [CUSTOMER_TYPE.PERSON]: getAccidentList,
  [CUSTOMER_TYPE.ENTERPRISE]: accidentList,
}

export default {
  props: ['customerId', 'customerType'],
  data() {
    const { configData } = diffConfigFn.call(this, { dealWithData: this.dealWithData })
    configData.tableData.apiFn = API_CONF[this.customerType]
    return {
      configData,
    }
  },
  methods: {
    dealWithData(params) {
      params.customerId = this.customerId
      params.customerType = Number(this.customerType)
    },
  },
}
</script>
